/**
 * @generated SignedSource<<60007c416b9a9745eea8a78b60b4fe07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubInvoiceModelStatusChoices = "CANCELLED" | "DRAFT" | "OVERPAID" | "PAID" | "PENDING" | "REFUND" | "SENT" | "%future added value";
export type UpdateInvoiceStatusInput = {
  clientMutationId?: string | null | undefined;
  draftInvoiceEmail?: boolean | null | undefined;
  invoiceId: string;
  preferText?: boolean | null | undefined;
  relatedInvoiceId?: string | null | undefined;
  sendInvoice?: boolean | null | undefined;
  sentDate?: string | null | undefined;
  status: string;
};
export type UpdateInvoiceStatusMutation$variables = {
  input: UpdateInvoiceStatusInput;
};
export type UpdateInvoiceStatusMutation$data = {
  readonly updateInvoiceStatus: {
    readonly errors: any | null | undefined;
    readonly invoice: {
      readonly amountPaid: number | null | undefined;
      readonly dueDate: string | null | undefined;
      readonly id: string;
      readonly initialSentTimestamp: string | null | undefined;
      readonly payments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly status: PianofunclubInvoiceModelStatusChoices;
    } | null | undefined;
    readonly relatedInvoice: {
      readonly id: string;
      readonly otherInvoicesForBlock: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly createdOn: string;
            readonly id: string;
            readonly invoiceNumber: string;
            readonly status: PianofunclubInvoiceModelStatusChoices;
            readonly totalAmount: number | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      };
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type UpdateInvoiceStatusMutation = {
  response: UpdateInvoiceStatusMutation$data;
  variables: UpdateInvoiceStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateInvoiceStatusPayload",
    "kind": "LinkedField",
    "name": "updateInvoiceStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceNode",
        "kind": "LinkedField",
        "name": "invoice",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "initialSentTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amountPaid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentNodeConnection",
            "kind": "LinkedField",
            "name": "payments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceNode",
        "kind": "LinkedField",
        "name": "relatedInvoice",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceNodeConnection",
            "kind": "LinkedField",
            "name": "otherInvoicesForBlock",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "invoiceNumber",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdOn",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateInvoiceStatusMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateInvoiceStatusMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cebd0b411a429ed5ab63f7ab2a16f31c",
    "id": null,
    "metadata": {},
    "name": "UpdateInvoiceStatusMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateInvoiceStatusMutation(\n  $input: UpdateInvoiceStatusInput!\n) {\n  updateInvoiceStatus(input: $input) {\n    success\n    errors\n    invoice {\n      id\n      status\n      initialSentTimestamp\n      dueDate\n      amountPaid\n      payments {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n    relatedInvoice {\n      id\n      otherInvoicesForBlock {\n        edges {\n          node {\n            id\n            invoiceNumber\n            status\n            totalAmount\n            createdOn\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0410a108b3270ff9b027b9e47cbe074";

export default node;
